import { DomainsPermissions } from '../../constants';
export const getPurchasePermissions = async _ref => {
  let {
    httpClient
  } = _ref;
  const {
    domainsAccount
  } = (await import('../ApiClients/DomainsApiClient')).DomainsApiClient.queries({
    httpClient
  });
  const account = await domainsAccount({});
  if (!(account != null && account.domainPermissions)) {
    return {
      hasPermission: false
    };
  }
  const isSiteLevel = !!account.msid;
  const userPermissions = new Set(account.domainPermissions ?? []);
  return {
    hasPermission: userPermissions.has(isSiteLevel ? DomainsPermissions.SiteLevelPurchaseDomain : DomainsPermissions.AccountLevelPurchaseDomain)
  };
};
//# sourceMappingURL=getPurchasePermissions.js.map